const surveyApi = {
  surveyAnswer: '/api/survey-answer'
}
export default surveyApi



// WEBPACK FOOTER //
// ./src/config/surveyApi.js